<template>
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_9234_68364)">
      <path
        d="M25.5995 10.12L22.3095 2.46C22.1895 2.18 21.9195 2 21.6195 2H10.5395C10.2395 2 9.95954 2.18 9.84954 2.46L6.55954 10.12C5.11954 13.48 6.54954 17.37 9.80954 19L14.7295 21.46C15.0695 21.63 15.2895 21.98 15.2895 22.36V28.72H11.7995C11.3995 28.72 11.0495 29.03 11.0395 29.44C11.0295 29.85 11.3595 30.18 11.7695 30.18H20.3495C20.7495 30.18 21.0995 29.87 21.1095 29.46C21.1195 29.05 20.7895 28.72 20.3795 28.72H16.8295V22.37C16.8295 21.99 17.0495 21.64 17.3895 21.47L22.3395 18.99C25.6095 17.37 27.0395 13.47 25.5995 10.12Z"
        fill="url(#paint0_linear_9234_68364)"
      />
      <path
        d="M25.5995 10.12L22.3095 2.46C22.1895 2.18 21.9195 2 21.6195 2H10.5395C10.2395 2 9.95954 2.18 9.84954 2.46L6.55954 10.12C5.11954 13.48 6.54954 17.37 9.80954 19L14.7295 21.46C15.0695 21.63 15.2895 21.98 15.2895 22.36V28.72H11.7995C11.3995 28.72 11.0495 29.03 11.0395 29.44C11.0295 29.85 11.3595 30.18 11.7695 30.18H20.3495C20.7495 30.18 21.0995 29.87 21.1095 29.46C21.1195 29.05 20.7895 28.72 20.3795 28.72H16.8295V22.37C16.8295 21.99 17.0495 21.64 17.3895 21.47L22.3395 18.99C25.6095 17.37 27.0395 13.47 25.5995 10.12Z"
        fill="url(#paint1_linear_9234_68364)"
      />
      <path
        d="M25.5995 10.12L22.3095 2.46C22.1895 2.18 21.9195 2 21.6195 2H10.5395C10.2395 2 9.95954 2.18 9.84954 2.46L6.55954 10.12C5.11954 13.48 6.54954 17.37 9.80954 19L14.7295 21.46C15.0695 21.63 15.2895 21.98 15.2895 22.36V28.72H11.7995C11.3995 28.72 11.0495 29.03 11.0395 29.44C11.0295 29.85 11.3595 30.18 11.7695 30.18H20.3495C20.7495 30.18 21.0995 29.87 21.1095 29.46C21.1195 29.05 20.7895 28.72 20.3795 28.72H16.8295V22.37C16.8295 21.99 17.0495 21.64 17.3895 21.47L22.3395 18.99C25.6095 17.37 27.0395 13.47 25.5995 10.12Z"
        fill="url(#paint2_radial_9234_68364)"
      />
      <path
        d="M11.7993 28.7197C11.3993 28.7197 11.0493 29.0297 11.0393 29.4397C11.0293 29.8497 11.3593 30.1797 11.7693 30.1797H20.3493C20.7493 30.1797 21.0993 29.8697 21.1093 29.4597C21.1193 29.0497 20.7893 28.7197 20.3793 28.7197C7.27935 28.7197 24.1912 28.7197 11.7993 28.7197Z"
        fill="url(#paint3_linear_9234_68364)"
      />
      <path
        d="M11.7993 28.7197C11.3993 28.7197 11.0493 29.0297 11.0393 29.4397C11.0293 29.8497 11.3593 30.1797 11.7693 30.1797H20.3493C20.7493 30.1797 21.0993 29.8697 21.1093 29.4597C21.1193 29.0497 20.7893 28.7197 20.3793 28.7197C7.27935 28.7197 24.1912 28.7197 11.7993 28.7197Z"
        fill="url(#paint4_radial_9234_68364)"
      />
      <path
        d="M11.7993 28.7197C11.3993 28.7197 11.0493 29.0297 11.0393 29.4397C11.0293 29.8497 11.3593 30.1797 11.7693 30.1797H20.3493C20.7493 30.1797 21.0993 29.8697 21.1093 29.4597C21.1193 29.0497 20.7893 28.7197 20.3793 28.7197C7.27935 28.7197 24.1912 28.7197 11.7993 28.7197Z"
        fill="url(#paint5_radial_9234_68364)"
      />
      <path
        d="M11.7993 28.7197C11.3993 28.7197 11.0493 29.0297 11.0393 29.4397C11.0293 29.8497 11.3593 30.1797 11.7693 30.1797H20.3493C20.7493 30.1797 21.0993 29.8697 21.1093 29.4597C21.1193 29.0497 20.7893 28.7197 20.3793 28.7197C7.27935 28.7197 24.1912 28.7197 11.7993 28.7197Z"
        fill="url(#paint6_radial_9234_68364)"
      />
      <path
        d="M11.7993 28.7197C11.3993 28.7197 11.0493 29.0297 11.0393 29.4397C11.0293 29.8497 11.3593 30.1797 11.7693 30.1797H20.3493C20.7493 30.1797 21.0993 29.8697 21.1093 29.4597C21.1193 29.0497 20.7893 28.7197 20.3793 28.7197C7.27935 28.7197 24.1912 28.7197 11.7993 28.7197Z"
        fill="url(#paint7_radial_9234_68364)"
      />
      <path
        d="M11.7993 28.7197C11.3993 28.7197 11.0493 29.0297 11.0393 29.4397C11.0293 29.8497 11.3593 30.1797 11.7693 30.1797H20.3493C20.7493 30.1797 21.0993 29.8697 21.1093 29.4597C21.1193 29.0497 20.7893 28.7197 20.3793 28.7197C7.27935 28.7197 24.1912 28.7197 11.7993 28.7197Z"
        fill="url(#paint8_radial_9234_68364)"
      />
      <path
        d="M14.7295 21.46C15.0695 21.63 15.2895 21.98 15.2895 22.36V28.72C7.4383 28.72 27.2923 28.72 16.8295 28.72V22.37C16.8295 21.99 17.0495 21.64 17.3895 21.47L14.7295 21.46Z"
        fill="url(#paint9_linear_9234_68364)"
      />
      <path
        d="M14.7295 21.46C15.0695 21.63 15.2895 21.98 15.2895 22.36V28.72C7.4383 28.72 27.2923 28.72 16.8295 28.72V22.37C16.8295 21.99 17.0495 21.64 17.3895 21.47L14.7295 21.46Z"
        fill="url(#paint10_radial_9234_68364)"
      />
      <path
        d="M23.2095 10.0601H8.94947C8.51947 10.0601 8.11947 10.3201 7.94947 10.7201C6.82947 13.3401 7.93947 16.3801 10.4895 17.6601L14.9495 19.8901C15.6595 20.2401 16.4895 20.2401 17.1995 19.8901L21.6695 17.6601C24.2195 16.3801 25.3395 13.3401 24.2095 10.7201C24.0395 10.3101 23.6495 10.0601 23.2095 10.0601Z"
        fill="#E21B95"
      />
      <path
        d="M23.2095 10.0601H8.94947C8.51947 10.0601 8.11947 10.3201 7.94947 10.7201C6.82947 13.3401 7.93947 16.3801 10.4895 17.6601L14.9495 19.8901C15.6595 20.2401 16.4895 20.2401 17.1995 19.8901L21.6695 17.6601C24.2195 16.3801 25.3395 13.3401 24.2095 10.7201C24.0395 10.3101 23.6495 10.0601 23.2095 10.0601Z"
        fill="url(#paint11_radial_9234_68364)"
      />
      <path
        d="M23.2095 10.0601H8.94947C8.51947 10.0601 8.11947 10.3201 7.94947 10.7201C6.82947 13.3401 7.93947 16.3801 10.4895 17.6601L14.9495 19.8901C15.6595 20.2401 16.4895 20.2401 17.1995 19.8901L21.6695 17.6601C24.2195 16.3801 25.3395 13.3401 24.2095 10.7201C24.0395 10.3101 23.6495 10.0601 23.2095 10.0601Z"
        fill="url(#paint12_radial_9234_68364)"
      />
      <path
        d="M23.2095 10.0601H8.94947C8.51947 10.0601 8.11947 10.3201 7.94947 10.7201C6.82947 13.3401 7.93947 16.3801 10.4895 17.6601L14.9495 19.8901C15.6595 20.2401 16.4895 20.2401 17.1995 19.8901L21.6695 17.6601C24.2195 16.3801 25.3395 13.3401 24.2095 10.7201C24.0395 10.3101 23.6495 10.0601 23.2095 10.0601Z"
        fill="url(#paint13_linear_9234_68364)"
      />
      <path
        d="M23.2095 10.0601H8.94947C8.51947 10.0601 8.11947 10.3201 7.94947 10.7201C6.82947 13.3401 7.93947 16.3801 10.4895 17.6601L14.9495 19.8901C15.6595 20.2401 16.4895 20.2401 17.1995 19.8901L21.6695 17.6601C24.2195 16.3801 25.3395 13.3401 24.2095 10.7201C24.0395 10.3101 23.6495 10.0601 23.2095 10.0601Z"
        fill="url(#paint14_radial_9234_68364)"
      />
      <path
        d="M23.2095 10.0601H8.94947C8.51947 10.0601 8.11947 10.3201 7.94947 10.7201C6.82947 13.3401 7.93947 16.3801 10.4895 17.6601L14.9495 19.8901C15.6595 20.2401 16.4895 20.2401 17.1995 19.8901L21.6695 17.6601C24.2195 16.3801 25.3395 13.3401 24.2095 10.7201C24.0395 10.3101 23.6495 10.0601 23.2095 10.0601Z"
        fill="url(#paint15_radial_9234_68364)"
      />
      <path
        d="M23.2095 10.0601H8.94947C8.51947 10.0601 8.11947 10.3201 7.94947 10.7201C6.82947 13.3401 7.93947 16.3801 10.4895 17.6601L14.9495 19.8901C15.6595 20.2401 16.4895 20.2401 17.1995 19.8901L21.6695 17.6601C24.2195 16.3801 25.3395 13.3401 24.2095 10.7201C24.0395 10.3101 23.6495 10.0601 23.2095 10.0601Z"
        fill="url(#paint16_linear_9234_68364)"
      />
      <path
        d="M22.3695 12.93C21.9795 12.93 21.6095 12.7 21.4495 12.32L18.1595 4.65995C17.9395 4.14995 18.1795 3.55995 18.6795 3.34995C19.1895 3.12995 19.7695 3.36995 19.9895 3.86995L23.2795 11.53C23.4995 12.04 23.2595 12.63 22.7595 12.84C22.6295 12.9 22.4995 12.93 22.3695 12.93Z"
        fill="url(#paint17_linear_9234_68364)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_9234_68364"
        x1="6"
        y1="11.6875"
        x2="26.1589"
        y2="11.6875"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#C7E7FF" />
        <stop
          offset="0.474356"
          stop-color="#C2E9FF"
        />
        <stop
          offset="0.682081"
          stop-color="#D3F6FF"
        />
      </linearGradient>
      <linearGradient
        id="paint1_linear_9234_68364"
        x1="16.0794"
        y1="2"
        x2="16.0794"
        y2="2.6875"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#BADEF8" />
        <stop
          offset="1"
          stop-color="#BADEF8"
          stop-opacity="0"
        />
      </linearGradient>
      <radialGradient
        id="paint2_radial_9234_68364"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(16.0794 13.5625) rotate(90) scale(16.6175 11.1615)"
      >
        <stop
          offset="0.731671"
          stop-color="#BFD7EF"
          stop-opacity="0"
        />
        <stop
          offset="0.866059"
          stop-color="#C0D7F0"
        />
      </radialGradient>
      <linearGradient
        id="paint3_linear_9234_68364"
        x1="15.9372"
        y1="28.8904"
        x2="16.0743"
        y2="31.2654"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#C7E7FF" />
        <stop
          offset="0.481106"
          stop-color="#D3F6FF"
        />
      </linearGradient>
      <radialGradient
        id="paint4_radial_9234_68364"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(16.2497 29.4497) rotate(90) scale(2.31567 5.625)"
      >
        <stop
          offset="0.82094"
          stop-color="#BEDBF3"
          stop-opacity="0"
        />
        <stop
          offset="1"
          stop-color="#BBDAF5"
        />
      </radialGradient>
      <radialGradient
        id="paint5_radial_9234_68364"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(11.0391 29.4497) rotate(90) scale(0.682862 1.13306)"
      >
        <stop stop-color="#BDDAF3" />
        <stop
          offset="1"
          stop-color="#BADAF5"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint6_radial_9234_68364"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(21.1872 29.4497) rotate(90) scale(0.581299 1.1875)"
      >
        <stop stop-color="#C3E2FB" />
        <stop
          offset="1"
          stop-color="#BADAF5"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint7_radial_9234_68364"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(18.5232 29.2185) rotate(88.6361) scale(0.328218 3.28217)"
      >
        <stop stop-color="#D3FBFF" />
        <stop
          offset="1"
          stop-color="#D4FCFF"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint8_radial_9234_68364"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(13.5935 29.7185) rotate(87.614) scale(0.375325 3.66641)"
      >
        <stop stop-color="#D3FBFF" />
        <stop
          offset="1"
          stop-color="#D4FCFF"
          stop-opacity="0"
        />
      </radialGradient>
      <linearGradient
        id="paint9_linear_9234_68364"
        x1="15.2499"
        y1="25.5625"
        x2="16.9687"
        y2="25.5625"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#BBDBF5" />
        <stop
          offset="0.318182"
          stop-color="#C7F1FF"
        />
        <stop
          offset="0.736364"
          stop-color="#CFF8FF"
        />
        <stop
          offset="1"
          stop-color="#C2E6FE"
        />
      </linearGradient>
      <radialGradient
        id="paint10_radial_9234_68364"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(16.4218 21.46) rotate(90) scale(1.49316 5.21875)"
      >
        <stop stop-color="#BDE9FF" />
        <stop
          offset="1"
          stop-color="#BDE9FF"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint11_radial_9234_68364"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(21.3124 11.4375) rotate(90) scale(5.625 9.55005)"
      >
        <stop
          offset="0.122222"
          stop-color="#FF73CB"
        />
        <stop
          offset="0.555556"
          stop-color="#FF38B5"
        />
        <stop
          offset="1"
          stop-color="#E6229D"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint12_radial_9234_68364"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(6.81244 11.6875) rotate(90) scale(3.75 6.3667)"
      >
        <stop stop-color="#FF73CB" />
        <stop
          offset="1"
          stop-color="#FF73CC"
          stop-opacity="0"
        />
      </radialGradient>
      <linearGradient
        id="paint13_linear_9234_68364"
        x1="16.4999"
        y1="20.5625"
        x2="16.4999"
        y2="15.1063"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.0916393"
          stop-color="#9162AC"
        />
        <stop
          offset="0.366557"
          stop-color="#A969BD"
        />
        <stop
          offset="0.664385"
          stop-color="#CC4AB7"
        />
        <stop
          offset="1"
          stop-color="#C940B0"
          stop-opacity="0"
        />
      </linearGradient>
      <radialGradient
        id="paint14_radial_9234_68364"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(14.8749 16.125) rotate(75.2033) scale(3.42612 4.22948)"
      >
        <stop stop-color="#C24AB6" />
        <stop
          offset="1"
          stop-color="#C348B4"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint15_radial_9234_68364"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(7.51416 16.1875) rotate(90) scale(3.5 5.70172)"
      >
        <stop stop-color="#B23E95" />
        <stop
          offset="1"
          stop-color="#B33C93"
          stop-opacity="0"
        />
      </radialGradient>
      <linearGradient
        id="paint16_linear_9234_68364"
        x1="16.0816"
        y1="10.0601"
        x2="16.0816"
        y2="10.625"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DA318B" />
        <stop
          offset="1"
          stop-color="#DA318B"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint17_linear_9234_68364"
        x1="18.9246"
        y1="4.12255"
        x2="22.8125"
        y2="13.375"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFFFFF" />
        <stop
          offset="0.982683"
          stop-color="#FFFFFF"
          stop-opacity="0"
        />
      </linearGradient>
      <clipPath id="clip0_9234_68364">
        <rect
          width="32"
          height="32"
          fill="#FFFFFF"
        />
      </clipPath>
    </defs>
  </svg>
</template>
